import zawada from '#/images/zawada.webp'
import butcher from '#/images/butcher.webp'
import camera from '#/images/camera.webp'
import Image from '#/app/components/content/Image'
import TypographyHeader from '../typography/TypographyHeading'
import Button from '../buttons/button'
import { Link } from '@remix-run/react'

export default function BannerSection() {
	return (
		<div className="mx-auto mt-[66px] flex h-[754px] w-full max-w-[720px] flex-col items-start px-0 py-0 md:h-[754px] md:max-w-[1440px] lg:h-[377px] lg:px-12">
			<div className="border-inline flex h-[294px] w-full flex-col items-start overflow-hidden rounded-t-[24px] border border-b-0 border-light p-0 dark:border-dark md:h-[147px] md:flex-row md:border-b">
				<Image
					containerClassName="border-inline border border-light dark:border-dark w-full md:w-[54%] h-[147px] overflow-hidden"
					className="relative mb-[-50%] h-full w-full object-cover"
					imageUrl={zawada}
					imageAlt="Zawada"
				/>
				<Image
					containerClassName="border-inline border border-light dark:border-dark w-full md:w-[46%] h-[147px] overflow-hidden"
					className="relative mb-[-50%] h-full w-full object-cover"
					imageUrl={camera}
					imageAlt="Camera"
				/>
			</div>
			<div className="border-inline flex h-[460px] w-full flex-col items-center justify-normal overflow-hidden rounded-b-[24px]  border border-t-0 border-light p-0 dark:border-dark md:h-[230px] md:flex-row md:items-start md:justify-center md:border-t">
				<div className="border-inline py-auto flex h-[230px] w-full flex-col justify-center border border-light bg-uiPrimaryLight text-left dark:border-dark dark:bg-uiPrimaryDark md:w-[54%]">
					<TypographyHeader
						additionalClasses="px-[47px] text-textPrimaryLight dark:text-textPrimaryDark text-headerSmall md:text-headerSmall lg:text-headerSmall xl:text-headerMedium"
						size="medium"
						isBold={false}
					>
						Atomic Lore™ is the 1st of its kind web3 directory showcasing data
						that is cryptographically signed
					</TypographyHeader>
					<div className="flex flex-col items-center gap-x-4 gap-y-2 px-[47px] pt-6 sm:flex-row">
						<Link to="/" className="w-full sm:w-auto">
							<Button
								variant="primary"
								size="medium"
								additionalClasses="w-full"
							>
								Build your Lore
							</Button>
						</Link>
						<a
							href="https://www.atomicform.com/lore#about-lore"
							target="_blank"
							rel="noreferrer"
							className="w-full sm:w-auto"
						>
							<Button
								variant="secondary"
								size="medium"
								additionalClasses="w-full"
							>
								Learn More
							</Button>
						</a>
					</div>
				</div>
				<Image
					containerClassName="border-inline border border-light dark:border-dark w-full md:w-[46%] h-[230px] overflow-hidden"
					className="relative mb-[-50%] h-full w-full object-cover"
					imageUrl={butcher}
					imageAlt="Butcher"
				/>
			</div>
		</div>
	)
}
